import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './LocationDetails.metadata.json5';
import styles from './LocationDetails.module.scss'

function LocationDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { yourHomeVM, updateSubmissionVM, showErrors, findInvalidComponent, onValidate, 
        isEitherChangeOrRenewal } = props;
    const LOCATION_COMPONENT = 'LocationDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(LOCATION_COMPONENT);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, LOCATION_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, LOCATION_COMPONENT);
    }, [findInvalidComponent, isComponentValid])

    const navigateToGoogleMaps = useCallback(() => {
        const url =  'https://maps.google.com/';

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank');
    }, []);

    const getCoastalZoneAvailableValues = useCallback(() => {
        const availableTypes = _.get(yourHomeVM, 'availableCoastalZoneTypes_TWIA.value');
        const typeListValues = yourHomeVM.coastalZoneType_TWIA.aspects.availableValues;
        
        return _.sortBy(
            _.filter(typeListValues, (value) => 
            _.includes(availableTypes, value.code)).map(key => ({
                name: translator({
                    id: key.name,
                    defaultMessage: key.name,
                }),
                code: key.code,
            }))
        )
    }, [translator, yourHomeVM]);

    const isMapVisible = useCallback(() => 
    // eslint-disable-next-line no-secrets/no-secrets
    _.get(yourHomeVM, 'primaryAddress_TWIA.eastOfHighway146_TWIA.aspects.visible') === true
    , [yourHomeVM]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        coastalZone: {
            availableValues: yourHomeVM.coastalZoneType_TWIA 
            ? getCoastalZoneAvailableValues() : [],
            readOnly: isEitherChangeOrRenewal
        },
        googleMaps: {
            visible: isMapVisible()
        },
        eastHighway: {
            readOnly: isEitherChangeOrRenewal
        }
    };

    const writeValue = useCallback((value, path) => {
        _.set(yourHomeVM, path, value);
        updateSubmissionVM(yourHomeVM);
    }, [updateSubmissionVM, yourHomeVM]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            googleMapsLink: navigateToGoogleMaps
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={yourHomeVM}
            overrideProps={overrideProps}
            showErrors={showErrors}
            // onModelChange={updateWizardData}
            onValidationChange={setComponentValidation}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

LocationDetails.propTypes = wizardProps;
export default LocationDetails;
